export default "__VITE_ASSET__BSm9RyID__"